<template>
  <tk-hotel-modal :click-to-close="true" @closed="$emit('close')">
    <section class="hotelModal">
      <div class="modalHeader">
        <tk-link class="modalBack" @click="$emit('close')">
          <tk-svg-icon class="icoBack" icon="prev" />
          戻る
        </tk-link>
      </div>
      <div class="hotelModalInner">
        <div class="hotelSectionInner">
          <p v-if="noSmoking" class="caution">
            <tk-svg-icon class="icoNosmoke" icon="nosmoke" />
            禁煙の客室です。
          </p>
          <p class="hotelH2">{{ roomTypeName }}</p>

          <div class="hotelRoomBox">
            <div class="showText">
              <input id="showText10" type="checkbox" />
              <!-- eslint-disable vue/no-v-html -->
              <div
                ref="introductionDiv"
                class="showTextArea"
                v-html="introduction"
              >
                {{ introduction }}
              </div>
              <!--eslint-enable-->
              <label
                v-show="showMoreButton"
                for="showText10"
                class="showTextBtn"
              >
                <tk-svg-icon class="icoMore" icon="down" />
              </label>
            </div>
          </div>

          <div class="hotelRoomBox">
            <dl class="hotelRoomBoxItem">
              <dt>
                <tk-svg-icon class="icoPeople" icon="people" />
                {{
                  maxGuestNumber ? `定員1~${maxGuestNumber}名` : noInforMessage
                }}
              </dt>
            </dl>
            <dl class="hotelRoomBoxItem">
              <dt>
                <tk-svg-icon class="icoSize" icon="size" />
                {{ area ? `${area} 平米` : noInforMessage }}
              </dt>
            </dl>
            <dl class="hotelRoomBoxItem">
              <dt>
                <tk-svg-icon class="icoBed" icon="bed2" />
                {{ bedType }}
              </dt>
              <dd>{{ bedTypeInfo }}</dd>
            </dl>
            <dl class="hotelRoomBoxItem">
              <dt>
                <tk-svg-icon class="icoWifi" icon="wifi" view-box="0 0 35 25" />
                Wi-Fi
              </dt>
              <dd>{{ wifi || noInforMessage }}</dd>
            </dl>
            <dl class="hotelRoomBoxItem">
              <dt>
                <tk-svg-icon
                  class="icoAmenity"
                  icon="amenity"
                  view-box="0 0 25 35"
                />
                設備・アメニティ
              </dt>
              <dd>{{ amenity || noInforMessage }}</dd>
            </dl>
            <dl class="hotelRoomBoxItem">
              <dt>
                <tk-svg-icon class="icoBath" icon="bath" />
                水回り
              </dt>
              <dd>{{ bathRoom || noInforMessage }}</dd>
            </dl>
            <dl class="hotelRoomBoxItem">
              <dt>
                <tk-svg-icon class="icoBaby" icon="baby" />
                お子様の宿泊
              </dt>
              <dd>{{ accommodationChildren || noInforMessage }}</dd>
            </dl>
            <dl class="hotelRoomBoxItem">
              <dt>
                <tk-svg-icon class="icoBarrierFree" icon="barrier_free" />
                バリアフリー
              </dt>
              <dd>{{ barrierFree || noInforMessage }}</dd>
            </dl>
            <dl class="hotelRoomBoxItem">
              <dt>
                <tk-svg-icon class="icoInfo" icon="info" />
                備考
              </dt>
              <dd>{{ note || noInforMessage }}</dd>
            </dl>
          </div>

          <div class="hotelRoomBox">
            <ul class="hotelRoomBoxImage">
              <li v-for="(img, idx) in imageList" :key="`room-detail${idx}`">
                <img alt="客室の写真" :src="img" />
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="modalFooter">
        <tk-link class="hotelBtnMini" @click="$emit('close')">閉じる</tk-link>
      </div>
    </section>
  </tk-hotel-modal>
</template>

<script>
import TkSvgIcon from '../../atoms/TkIcon/TkSvgIcon.vue'
import TkLink from '../../atoms/TkLink/TkLink'
import TkHotelModal from '../../atoms/TkGlobalModal/TkHotelModal'

export default {
  name: 'RoomTypeDetailModal',
  components: {
    TkLink,
    TkHotelModal,
    TkSvgIcon,
  },
  props: {
    noSmoking: {
      type: Boolean,
      default: false,
    },
    roomTypeName: {
      type: String,
      default: '',
    },
    introduction: {
      type: String,
      default: '',
    },
    imageList: {
      type: Array,
      default() {
        return []
      },
    },
    maxGuestNumber: {
      type: Number,
      required: true,
    },
    area: {
      type: Number,
      required: true,
    },
    bedType: {
      type: String,
      required: true,
    },
    bedTypeInfo: {
      type: String,
      default: '',
    },
    wifi: {
      type: String,
      default: '',
    },
    bathRoom: {
      type: String,
      default: '',
    },
    amenity: {
      type: String,
      default: '',
    },
    accommodationChildren: {
      type: String,
      default: '',
    },
    barrierFree: {
      type: String,
      default: '',
    },
    note: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showMoreButton: false,
      noInforMessage: '情報なし',
    }
  },
  mounted() {
    setTimeout(() => {
      this.showMoreButton = this.isTextClamped()
    }, 0)
  },
  methods: {
    isTextClamped() {
      if (!this.$refs.introductionDiv) return false
      const elm = this.$refs.introductionDiv
      return elm.scrollHeight > elm.clientHeight
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@ota-frontend/ui/src/scss/components/RoomTypeDetailModal.scss';
</style>
